import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { CountdownTimer } from './components/CountdownTimer';
import { CrisisMoment } from './components/CrisisMoment';
import { ProblemSolution } from './components/ProblemSolution';
import { Features } from './components/Features';
import { Proof } from './components/Proof';
import { Offer } from './components/Offer';
import { Objections } from './components/Objections';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  const [timerCompleted, setTimerCompleted] = useState(false);
  const handleTimerComplete = () => {
    setTimerCompleted(true);
    // Scroll to the content when it appears
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <div className="relative bg-gradient-to-b from-black via-orange-950 to-orange-900 text-white min-h-screen w-full overflow-x-hidden" data-id="element-0">
      {/* Grid overlay */}
      <div className="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:40px_40px] pointer-events-none" data-id="element-1"></div>
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-4" data-id="element-2">
        {/* Always visible content */}
        <Hero data-id="element-3" />
        <CountdownTimer initialTimeInSeconds={300} onComplete={handleTimerComplete} data-id="element-4" />
        {/* Content revealed after timer completes */}
        {timerCompleted && <>
            <CrisisMoment data-id="element-5" />
            <ProblemSolution data-id="element-6" />
            <Features data-id="element-7" />
            <Proof data-id="element-8" />
            <Offer data-id="element-9" />
            <Objections data-id="element-10" />
            <CallToAction data-id="element-11" />
          </>}
        <Footer data-id="element-12" />
      </div>
    </div>;
}